import {
  FlexBox,
  ImageThumbnail,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { Product } from '../../data-access';

interface UniversalUpgradeProductCardProps {
  learnMoreLink?: string;
  upgrade: Product;
  onSeeMore?: () => void;
}

const UniversalUpgradeProductCard: React.FC<
  PropsWithChildren<UniversalUpgradeProductCardProps>
> = ({ upgrade, learnMoreLink, onSeeMore, children }) => (
  <FlexBox
    flexDirection={['column', 'row']}
    alignItems={'center'}
    justifyContent={'space-between'}
    gap={3}
  >
    <ImageThumbnail
      imageUrl={upgrade.images.at(0)?.url}
      sx={{
        aspectRatio: '4/3',
        width: '6rem',
        alignSelf: ['center', 'flex-start'],
      }}
    />
    <FlexBox
      flexDirection={'column'}
      alignItems={['center', 'flex-start']}
      flex={1}
      gap={1}
    >
      <Typography variant="h4">{upgrade.name}</Typography>
      <SanitizedTrimmedHtml
        html={upgrade.description}
        maxLength={200}
        variant="body2"
        onSeeMore={onSeeMore}
      />
      {learnMoreLink && (
        <Typography
          component={Link}
          color="tertiary"
          variant="subtitle2"
          to={learnMoreLink}
        >
          Learn more
        </Typography>
      )}
      {children}
    </FlexBox>
  </FlexBox>
);

export default UniversalUpgradeProductCard;
